<template>
  <div class="edit-url">
    <div v-if="!hideHeader" class="edit-url__title">
      <a :href="urlData.url" class="edit-url__title-link" target="_blank" :class="{'edit-url__title-link_disabled': isUrlNotClickable}">
        <base-truncate-label
          :label="urlData.url"
          :shrink="0.75"
          :font="'34px Roboto'"
          :watchClass="'edit-url__title'"/>
      </a>
    </div>
    <div class="edit-url__recom-content">
      <a v-if="isPublished" target="_blank" class="edit-url__recom-content_header" :href="urlData.url">{{ urlData.title }}</a>
      <div v-else class="edit-url__recom-content_header">{{ urlData.title }}</div>
      <div class="edit-url__recom-content_content">{{ urlData.description }}</div>
    </div>
    <label class="edit-url__input">
      <div class="edit-url__content-brief">
        <router-link :to="`/content-briefs/${urlData.contentBriefId}/${isPublished ? 'progress' : 'strategy'}`"
                     class="edit-url__brief-name" v-if="urlData.contentBriefName" target="_blank"
                     :class="{'edit-url__brief-name_disabled': isContentBriefDisabled}">
          <base-truncate-label
            checkAllDocument
            :label="urlData.contentBriefName"
            :shrink="0.75"
            :watchClass="'edit-url__content-brief'"/>
        </router-link>
        <router-link class="edit-url__link-button" :to="`/content-briefs/${urlData.contentBriefId}/${isPublished ? 'progress' : 'strategy'}`"
                     v-if="urlData.contentBriefName && !isContentBriefDisabled" target="_blank">
          <base-material-design-icon icon="file" class="edit-url__link-icon"/>
        </router-link>
      </div>
    </label>
    <div class="edit-url__header">
      <div class="edit-url__title-wrapper">
        <div class="edit-url__info-item">
          <div class="edit-url__header-title">Target Date</div>
          <base-date-picker-button
            v-if="!isCurrentUserClientCollaborator"
            class="edit-url__date"
            v-model="date"
          ></base-date-picker-button>
          <span class="edit-url__date" v-else>{{disabledDate}}</span>
        </div>
        <div class="edit-url__info-item">
          <div class="edit-url__header-title">URL Status</div>
          <base-select
            :disabled="isClientColoborator"
            class="create-url__section"
            border-less="true"
            :options="urlStatuses"
            v-model="status"
            alignLeft="true"
            :max-height-list="450"
            :titleStyle="titleStyle"
            :headerStyle="selectStyle"
          />
        </div>
        <div class="edit-url__info-item">
          <div class="edit-url__header-title">Section</div>
          {{urlData.section}}
        </div>
        <div class="edit-url__info-item">
          <div class="edit-url__header-title">Page Type</div>
          {{urlData.pageType}}
        </div>
        <div class="edit-url__info-item">
          <div class="edit-url__header-title">Total MSV</div>
          {{urlData.msv | commaDividedNumber}}
        </div>
        <div class="edit-url__info-item">
          <div class="edit-url__header-title">#KW</div>
          {{urlData.keywords}}
        </div>
      </div>
    </div>
    <div class="edit-url__controls">
      <button class="edit-url__button edit-url__button_cancel"
              @click.prevent="close()">Cancel
      </button>
      <button class="edit-url__button edit-url__button_submit"
              v-if="!isCurrentUserClientCollaborator"
              @click.prevent="apply()">
        Apply
      </button>
    </div>
  </div>
</template>

<script>
import Filters from '@/common/Filters'
import ToasterService from '@/services/toasterService'
import moment from 'moment'
import { mapState } from 'vuex'
import BaseModalMixins from '@/common/BaseModalMixins'
import _ from 'lodash'

const SELECT_STYLE = {
  'background-color': 'transparent',
  color: '#284aff',
  'text-decoration': 'underline',
  height: '16px!important'
}
/**
   * Popup for editing Url (event with Publishing type)
   */
export default {
  name: 'EditUrlPopup',
  mixins: [BaseModalMixins],
  props: {
    'url': Object,
    hideHeader: {
      type: Boolean,
      default: false
    }
  },
  // mounted () {
  //   const width = Array.from(document.getElementsByClassName('edit-url__info-item')).reduce((acc, item) => {
  //     acc += this.calculateElementWidth(item)
  //     return acc
  //   }, 0)
  //   const header = parseInt(window.getComputedStyle(document.getElementsByClassName('edit-url__header')[0]).paddingLeft)
  //   const padding = parseInt((document.getElementsByClassName('edit-url__title-wrapper')[0].offsetWidth - (header * 2) - width) / 6)
  //   this.elementStyle = {
  //     'padding-left': `${parseInt(padding / 2)}px`,
  //     'padding-right': `${parseInt(padding / 2)}px`
  //   }
  // },
  data () {
    return {
      description: '',
      date: this.calculateDate(this.url['start_date'] || ''),
      status: '',
      pageType: '',
      // elementStyle: {},
      isValidating: false,
      titleStyle: {
        overflow: 'visible'
      },
      pickerProps: {
        placeholder: 'Enter Date',
        class: 'input-date',
        readonly: true
      }
    }
  },
  watch: {
    urlData: {
      handler (value) {
        this.status = value.statusId
        this.pageType = value.pageTypeId
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    ...mapState('rankZoneCommon', {
      urlStatuses (state) {
        const statuses = state.urlStatuses.map(this.convertToOptions) || []
        return statuses
      }
    }),
    isPublished () {
      const urlStatus = this.urlStatuses.find(i => i.value === this.urlData.statusId) || {}
      return urlStatus && urlStatus.label && urlStatus.label.toLowerCase() === 'published'
    },
    urlData () {
      const date = this.url['start_date'] || ''
      const section = _.get(this.url, 'section.name') || 'None'
      const statusId = _.get(this.url, 'status._id') || ''
      const contentBriefName = _.get(this.url, 'content_brief.name')
      const contentBriefId = _.get(this.url, 'content_brief._id')
      const contentBriefStatus = _.get(this.url, 'brief_status.name')
      const pageTypeId = _.get(this.url, 'page_type._id') || 'None'
      const pageType = _.get(this.url, 'page_type.name') || 'None'
      const url = this.url.url
      const keywords = this.url['keywords'] || this.url['keywords'] === 0 ? this.url['keywords'] : ''
      const msv = (this.url['msv'] || this.url['msv'] === 0) ? this.url['msv'] : ''
      const title = _.get(this.url, 'tag_title', '')
      const description = _.get(this.url, 'tag_meta_description', '')
      const truncatedUrl = this.getTruncatedUrl(url)
      return {
        date,
        statusId,
        section,
        contentBriefName,
        title,
        description,
        truncatedUrl,
        contentBriefId,
        pageTypeId,
        pageType,
        url,
        contentBriefStatus,
        keywords,
        msv
      }
    },
    disabledDate () {
      return moment.utc(this.date).format('MMM DD, YYYY')
    },
    isContentBriefDisabled () {
      return this.urlData.contentBriefStatus === 'Draft' && !this.isCurrentUserAgent
    },
    popupTitle () {
      return this.isCurrentUserClientCollaborator ? 'URL' : 'Edit URL'
    },
    selectStyle () {
      return SELECT_STYLE
    },
    isUrlNotClickable () {
      const status = this.urlStatuses.find(item => item.value === this.status)
      return status && status.label !== 'Published'
    },
    isClientColoborator () {
      return this.currentUser.isClientCollaborator()
    }
  },
  methods: {
    close () {
      this.$emit('cancel')
    },
    getTruncatedUrl (url) {
      const truncateUrl = url.replace(/(^\w+:|^)\/\//, '')
      if (truncateUrl.length <= 60) {
        return truncateUrl
      }
      const splitedUrl = truncateUrl.split('/')
      const lastSymbolsCount = 57 - splitedUrl[0].length
      return `${splitedUrl[0]}...${truncateUrl.slice(truncateUrl.length - lastSymbolsCount)}`
    },
    isFormInvalid () {
      return this.isDescriptionError
    },
    convertToOptions (item) {
      return {
        value: item._id,
        label: item.label
      }
    },
    apply () {
      this.isValidating = true
      if (this.isFormInvalid()) {
        return
      }
      this.$emit('apply', {
        description: this.description,
        date: this.date,
        status: this.status,
        pageType: this.pageType
      })
    },
    calculateDate (date) {
      if (!date) return ''
      // hack for Safary
      // date = date.replace(/ /g, 'T')
      // if (!date.includes('T')) {
      //   date += 'T00:00:00'
      // }
      return moment(date).toDate()
    },
    calculateElementWidth (el) {
      return el.offsetWidth
    },
    getPickerProps () {
      if (this.isCurrentUserClientCollaborator) {
        this.pickerProps.class += ' input-date_disabled'
      } else return this.pickerProps
    },
    copyToClipboard () {
      const firstPath = window.location.href.split(this.$route.path)[0]
      const copyPath = firstPath + `/content-briefs/${this.urlData.contentBriefId}`
      this.$copyText(copyPath)
        .then(
          e => {
            ToasterService.showToast(ToasterService.INFO_TYPE, 'Share link copied to clipboard')
          },
          err => {
            ToasterService.showToast(ToasterService.ERROR_TYPE, 'Can not copy link. Please, copy it manually')
          }
        )
    }
  },
  filters: {
    ...Filters
  }
}
</script>

<style lang="scss" scoped>
  .edit-url {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 40px;

    &__title-link {
      flex: 1 1;
      @include ellipsis;
      text-decoration: none;
      color: $rfx-dark-march;

      &_disabled {
        display: inline-block;
        pointer-events: none;
        cursor: default;
      }
    }

    &__recom-content {
      &_header {
        font-size: 20px;
        font-weight: 500;
        line-height: 26px;
        color: $rfx-greyish-brown;
        text-decoration: none;
        margin-bottom: 8px;
      }

      a {
        color: #284aff;
      }

      &_content {
        font-size: 16px;
        line-height: 20px;
        color: $rfx-greyish-brown;
      }
    }

    &__title-wrapper {
      display: flex;
    }

    &__title {
      height: 40px;
      text-align: center;
      font-size: 34px;
      font-weight: 500;
      margin: 9px 0 35px;
      color: $rfx-dark-march;
      @include ellipsis;
    }

    &__header {
      border-top: 2px solid #dbdee5;
      height: 104px;
      display: flex;
      flex-direction: column;
      margin: 0 -40px;
      padding-right: 40px;
      padding-left: 40px;
    }

    &__header-title {
      color: $rfx-shaded-grey;
      font-weight: bold;
      font-size: 11px;
      line-height: 16px;
      border: none;
      display: flex;
      align-items: flex-end;
      margin-bottom: 8px;
      margin-top: 24px;
      white-space: nowrap;
    }

    &__info-item {
      color: $rfx-dark-march;
      border: none;
      margin-right: 47px;
    }

    &__brief-name {
      text-decoration: none;
      font-size: 14px;
      line-height: 20px;
      font-weight: normal !important;
      color: $rfx-bright-blue;

      &_disabled {
        pointer-events: none;
        opacity: 0.7;
      }

      &:hover {
        text-decoration: underline;
      }
    }

    &__input {
      display: flex;
      flex-direction: column;
      position: relative;
      margin: 24px 0;

      &_invalid[type='text'] {
        border: 1px solid $rfx-red;
        border-radius: 4px;
      }
    }

    &__label {
      display: block;
      font-weight: 600;
      margin-bottom: 5px;
      color: $rfx-dark-march;
    }

    &__controls {
      display: flex;
      justify-content: flex-end;
    }

    &__link-icon {
      font-size: 18px;
      color: $rfx-dark-march;

      &:hover {
        color: $rfx-bright-turquoise;
      }
    }

    &__link-button {
      position: absolute;
      z-index: 1;
      width: 50px;
      height: 50px;
      top: -14px;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    &__button {
      width: 100px;
      height: 40px;
      border-radius: 4px;
      font-size: 10px;
      font-weight: 900;
      text-transform: uppercase;
      margin-left: 30px;
      border: none;
      outline: none;
      cursor: pointer;

      &_submit {
        background-color: $rfx-medium-march;
        color: #fff;

        &:disabled {
          pointer-events: none;
          background-color: #fff;
          color: $rfx-neutral-grey;
          cursor: default;
        }
      }

      &_disabled {
        pointer-events: none;
        background-color: #fff;
        color: $rfx-neutral-grey;
        cursor: default;
      }

      &_cancel {
        color: $rfx-dark-march;
        background-color: #fff;
      }
    }

    &__content-brief {
      outline: none;
      font-size: 14px;
      font-weight: 600;
      color: $rfx-dark-march;
      position: relative;
    }

    &__url {
    }

    &__link {
      &-wrapper {
        position: relative;
        @extend .edit-url__content-brief;
        background-color: $rfx-light-steel;
      }

      &-field[type='text'] {
        width: 100%;
        box-sizing: border-box;
        padding-right: 60px;
        font-weight: 500;
        @include ellipsis;
      }
    }

    &__date {
      margin-top: -8px;
    }
  }

  .form-control {
    height: 50px;
    padding: 0 20px;
    border: 2px solid $rfx-light-steel;
    outline: none;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 600;
    color: $rfx-dark-march;

    &::placeholder {
      color: $rfx-pearl;
      font-weight: normal;
      font-size: 14px;
    }

    &:disabled {
      background-color: $rfx-light-steel;
    }

    &_error {
      border-color: $rfx-red;
      color: $rfx-red;

      &::placeholder {
        color: $rfx-red;
        font-size: 13px;
      }

    }
  }

  .description {
    width: 100%;
    padding: 0;
    resize: none;
    outline: none;
    border: none;

    &::placeholder {
      color: $rfx-pearl;
      font-weight: normal;
      font-size: 14px;
    }

    &__wrapper {
      padding: 10px 20px;
      height: auto;
    }
  }

  .input-date {
    border: none;
    box-shadow: none;
    text-decoration: underline;
    background-color: transparent;
    padding: 0;
    color: $rfx-bright-blue;
    font-size: 13px;
    width: 85px;
    vertical-align: top;

    &_disabled {
      pointer-events: none;
    }

    &::placeholder {
      color: $rfx-bright-blue;
      text-decoration: underline;
      font-size: 13px;
    }

    &_error {
      &::placeholder {
        color: $rfx-red;
        text-decoration: underline;
        font-size: 13px;
      }
    }
  }

  .error {
    &__message-description,
    &__message {
      color: $rfx-red;
      position: absolute;
      top: 75px;
      font-size: 10px;
      font-weight: normal;
    }

    &__message-description {
      top: 154px;
      left: 0;
    }
  }

</style>
